/**
 * @file Card 面板容器
 * @description 后台内容卡片：Header / Body / Footer 插槽。
 *
 * @whenToUse 区块内容、表单分组、统计卡外壳。
 * @whenNotToUse Showcase 预览外框（用 ShowcaseCard）。
 */

import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/cn.ts'

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-border bg-sidebar',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export function CardHeader({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('flex items-center justify-between gap-2 border-b border-border px-4 py-2', className)}
      {...rest}
    >
      {children}
    </div>
  )
}

export function CardTitle({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3 className={cn('text-sm font-medium text-foreground', className)} {...rest}>
      {children}
    </h3>
  )
}

export function CardBody({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('p-4', className)} {...rest}>
      {children}
    </div>
  )
}

export function CardFooter({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'flex items-center justify-end gap-2 border-t border-border px-4 py-2',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}
